import DateDiff from 'date-diff';

import $conversion from '@/utils/conversion';

export default {
  simpleTime(value) {
    let result = '';
    let input = null;

    if (value) {
      input = new Date(value);
      result = `${input.getHours()}:${$conversion.twoDigits(input.getMinutes())}`;
    }

    return result;
  },

  simpleDate(value) {
    let result = '';
    let input = null;

    if (value) {
      input = new Date(value);
      result = `${input.getFullYear()}-${$conversion.twoDigits(input.getMonth() + 1)}-${$conversion.twoDigits(
        input.getDate()
      )}`;
    }

    return result;
  },

  dateTime(value) {
    let result = '';
    let input = null;

    if (value) {
      input = new Date(value);
      result = `${input.getFullYear()}-${$conversion.twoDigits(input.getMonth() + 1)}`;
      result += ` ${$conversion.twoDigits(input.getDate())} ${input.getHours()}:${$conversion.twoDigits(
        input.getMinutes()
      )}`;
    }

    return result;
  },

  timeToNow(value) {
    const inputTime = new Date(value);
    const timeB = inputTime.getTime() / 1000 + 172800;
    const now = new Date();

    let result = '';
    let seconds = 0;

    if (value) {
      seconds = timeB - now.getTime() / 1000;

      if (seconds < 60) {
        result = 'Less than 1 Min';
      } else if (seconds < 3600) {
        result = `${(seconds - (seconds % 60)) / 60} Mins`;
      } else if (seconds < 172800) {
        result = `${(seconds - (seconds % 3600)) / 3600} Hours`;
      } else {
        result = 'More than 48 hours';
      }

      result = `in ${result}`;
    }

    return result;
  },

  clientStatus(status) {
    let result = status;

    if (status !== 'OPEN') {
      result = 'Closing time:';
    }

    return result;
  },

  duration(dateA, dateB) {
    let result = '';
    const timeDiff = new DateDiff(new Date(dateA), new Date(dateB));
    const minutes = Math.abs(timeDiff.minutes());
    const hours = Math.abs(timeDiff.hours());
    const days = Math.abs(timeDiff.days());
    const weeks = Math.abs(timeDiff.weeks());
    const months = Math.abs(timeDiff.months());

    if (months >= 1) {
      result = `More than ${parseInt(months, 10)} months`;
    } else if (weeks >= 1) {
      result = `More than ${parseInt(weeks, 10)} weeks`;
    } else if (days >= 1) {
      result = `More than ${parseInt(days, 10)} days`;
    } else if (hours >= 1) {
      if (minutes > 60) {
        result = `${Math.floor(hours)} Hours `;
        result += `${Math.round(minutes) - Math.floor(hours) * 60} Mins`;
      } else {
        result = `${Math.round(minutes)} Mins`;
      }
    } else {
      result = `${Math.round(minutes)} Mins`;
    }

    return result;
  },

  humanReadableStatus(statusCode) {
    switch (statusCode) {
      case 'SUC':
        return 'Client completed all required HUB programs';
      case 'DISC':
        return 'Client no longer wished to participate in the HUB';
      case 'CIRC':
        return 'Client ended HUB service due to circumstances beyond their control (i.e. discharged from custody)';
      case 'S&S':
        return 'Client suspended from HUB or agency service due to safety and security reasons';
      default:
        return '';
    }
  },
};
